import { render, staticRenderFns } from "./totalReport.vue?vue&type=template&id=65a441d2&scoped=true&"
import script from "./totalReport.vue?vue&type=script&lang=js&"
export * from "./totalReport.vue?vue&type=script&lang=js&"
import style0 from "./totalReport.vue?vue&type=style&index=0&id=65a441d2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a441d2",
  null
  
)

export default component.exports